import {GlobalRecordBaseIntf} from '../global/global.types';

export interface MindRecordLogIntf extends GlobalRecordBaseIntf {
	note?: string;
	mind: MindPsycType[]
}

export interface MindRecordSumIntf extends GlobalRecordBaseIntf {

}

export interface MindConfIntf {
	id?: string;
	mind: MindPsycType;
}


export type MindPsycType =
	| 'ocd'
	| 'intrusive_thoughts'
	| 'manic'
	| 'dysregulated'
	| 'sensory_overload'
	| 'rumination'
	| 'mental_checking'
	| 'paranoia'
	| 'flashbacks'
	| 'hypersensitive'
	| 'overstimulated'
	| 'mind_wired'
	| 'mind_fog'
	| 'mental_rehearsal'
	| 'urge_to_fix'
	| 'mental_exhaustion'
	| 'shutdown';


export const PsycTypes: MindPsycType[] = [
	'ocd',
	'intrusive_thoughts',
	'manic',
	'dysregulated',
	'sensory_overload',
	'rumination',
	'mental_checking',
	'paranoia',
	'flashbacks',
	'hypersensitive',
	'overstimulated',
	'mind_wired',
	'mind_fog',
	'mental_rehearsal',
	'urge_to_fix',
	'mental_exhaustion',
	'shutdown'
]